export const TARGET_DATE = new Date('2025-06-15T00:00');

export const BOOK_A_DEMO_LINK =
  'https://meetings.hubspot.com/mharalson?uuid=df779104-51a2-43be-80fa-f8fc542c2ed7';
